import React from 'react';
import { isMobile, isIOS, isAndroid } from 'react-device-detect';
import PlayStoreBadge from './PlayStoreBadge';
import AppStoreBadge from './AppStoreBadge';
import AppLauncher from './AppLauncher';

const MomentumAppBanner = () => {
	if (!isMobile)
		return null;

	const launcher = <AppLauncher />;
	const appStoreBadge = isIOS && <AppStoreBadge />;
	const playStoreBagde = isAndroid && <PlayStoreBadge />;

	return <div className='badge-container'>{launcher}{appStoreBadge}{playStoreBagde}</div>
}

export default MomentumAppBanner;